<template>
  <PopWidget :isShow="isShowPopWidget" :style="style">
    <template v-slot:title>
      <img class="l-t-title" src="../../assets/geren/binding-wallet-info.png" />
    </template>
    <template v-slot:content>
      <div class="l-c-w-i">
        <div class="flex h row">
          <div class="platform">钱包平台</div>
          <div class="wallet-addr">钱包地址</div>
        </div>
        <div class="flex row" style="align-items:center" v-for="wallet of wallets">
          <div class="platform">
            {{ wallet.wallet_name }}
          </div>
          <input readonly v-model="wallet.address" class="wallet-addr" 
            :ref="`walletAddressEle_${wallet.id}`" />
          <img @click="copyClick(wallet.id)"
            class="copy-btn" src="../../assets/geren/copy-btn.png" />
        </div>
      </div>
      <div class="tips">温馨提示：如有疑问，请联系在线客服。</div>
    </template>
  </PopWidget>
</template>
<script>
import { mapMutations } from 'vuex'
import Tool from '../../common/Tool.js'
import PopWidget from '../common/PopWidget.vue'

export default {
  props:{
    style:Object,
    isShow:Number,
    wallets:{},
  },
  data(){
    return {
      isShowPopWidget:0,
    }
  },
  methods:{
    ...mapMutations(['popMsg']),
    copyClick(walletId){
      let eleRkey = `walletAddressEle_${walletId}`;
      let eles = this.$refs[eleRkey];
      if(eles && eles.length){
        let copyText = eles[0];
        Tool.copy(copyText);
        this.popMsg('已复制!')
      }
    },
  },
  watch:{
    isShow(n,o){
      this.isShowPopWidget = n;
    }
  },
  components:{
    PopWidget
  }
}
</script>
<style scoped lang="stylus">
.l-confirm-btn
  width .94rem
  margin-top .16rem
  transition transform .3s
  &:active
    transform scale(.8)
.l-c-w-i
  height 1.7rem
  overflow auto
  display flex
  flex-direction column
  width 100%
  border-top 1px solid transparent
  font-size .12rem
  padding 0 .03rem
  .row
    height .4rem
  .h
    height .3rem
    align-items center
    background-color #515151
  .platform
    width 1.08rem
  .wallet-addr
    width 2.9rem
    background none
    border none
  .copy-btn
    width .5rem
.tips
  font-size .12rem
  color #6b6b6b
</style>